const crypto = require('crypto');


const algorithm = 'aes-256-cbc'
const key32 = '1qaz@WSX1qaz@WSX1qaz@WSX1qaz@WSX'
const iv16 = '1qaz@WSX1qaz@WSX'


// 암호화 메서드
const cipher = (input_str) => {
    const cipher = crypto.createCipheriv(algorithm, key32, iv16)
    let result = cipher.update(input_str,'utf-8','base64')
    result += cipher.final('base64')
    // console.log(`암호화 - ${result}`)
    return result
}

// 복호화 메서드
const decipher = (enc_str) => {
    const decipher = crypto.createDecipheriv(algorithm, key32, iv16)
    let result2 = decipher.update(enc_str, 'base64', 'utf-8')
    result2 += decipher.final('utf-8')
    // console.log(`복호화 - ${result2}`)
    return result2
}


module.exports = {
    cipher,
    decipher
}